// mobile stiky button
$(".mobile-sticky-add-to-cart-button").click(function(){
   
	$(".product_form .add_to_cart").trigger("click");
});


$(document).ready(function(){
  $(".description-with-button-container button").click(function(){
    console.log(222)
    if( $(".description-control").hasClass("new-product-description")){
       $(".description-control").removeClass("new-product-description");
       $(this).find("span").text("Show Less");
    }else{
       $(".description-control").addClass("new-product-description");
       $(this).find("span").text("Show More");
    }
  });
});